import React from 'react'

const DieNameWiseReport = () => {
  return (
    <div>DieNameWiseReport</div>
  )
}

export default DieNameWiseReport